import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import {SMSService} from "../../../service/SMSService";
import {SendSMSEntityType} from "./SendSMSButtonProperties";

class SendSMSButtonStore {

    public content?: string;
    public entityIds: string[];
    public entityType: SendSMSEntityType;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;
    public error?: string;
    public success?: string;


    constructor(
        commonStore: CommonStore,
        entityIds: string[],
        entityType: SendSMSEntityType) {
        this.entityIds = entityIds;
        this.entityType = entityType;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.content);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async cleanModal() {
        this.content = undefined;
    }

    @action
    public async send(): Promise<boolean> {
        if (this.content) {
            this.loading = true;
            const response = this.entityType === "CLIENT"
                ? await SMSService.sendSMSToClients(this.entityIds, this.content)
                : await SMSService.sendSMSToAgencyClients(this.entityIds, this.content)

            this.commonStore.processErrors(response);
            this.loading = false;
            return response.success;
        }
        return false;
    }
}

export default SendSMSButtonStore;